
export enum EquipmentType {

  // *************************************************************
  // Favourite Gear
  // *************************************************************

  // Gear - My
  MyGearRegularNormal = 'MyGearRegularNormal',
  MyGearRegularMagic = 'MyGearRegularMagic',
  MyGearRegularRare = 'MyGearRegularRare',

  // ****** POE2 ******

  // Gear - Favourite - POE2 - Tiered
  MyGearRareT5 = 'MyGearRareT5',
  MyGearRareT4 = 'MyGearRareT4',
  MyGearRareT3 = 'MyGearRareT3',
  MyGearRareT2 = 'MyGearRareT2',
  MyGearMagicT5 = 'MyGearMagicT5',
  MyGearMagicT4 = 'MyGearMagicT4',
  MyGearMagicT3 = 'MyGearMagicT3',
  MyGearMagicT2 = 'MyGearMagicT2',

  // Gear - Favourite - POE2 - Tiered Low Tier
  MyGearLowerGearTierRareT5 = 'MyGearLowerGearTierRareT5',
  MyGearLowerGearTierRareT4 = 'MyGearLowerGearTierRareT4',
  MyGearLowerGearTierRareT3 = 'MyGearLowerGearTierRareT3',
  MyGearLowerGearTierMagicT5 = 'MyGearLowerGearTierMagicT5',
  MyGearLowerGearTierMagicT4 = 'MyGearLowerGearTierMagicT4',
  MyGearLowerGearTierMagicT3 = 'MyGearLowerGearTierMagicT3',

  // Gear - Favourite - POE2 - Exceptional
  MyGearExcellentExceptional = 'MyGearExcellentExceptional',
  MyGearGoodExceptional = 'MyGearGoodExceptional',
  MyGearExcellentILevel = 'MyGearExcellentILevel',
  MyGearGoodILevel = 'MyGearGoodILevel',

  // ****** POE1 ******

  // Gear - Favourite - POE1
  MyGearExcellentCraftingBase = 'MyGearExcellentCraftingBase',
  MyGearGoodCraftingBase = 'MyGearGoodCraftingBase',
  MyGearExcellentMemoryStrands = 'MyGearExcellentMemoryStrands',
  MyGearGoodMemoryStrands = 'MyGearGoodMemoryStrands',
  MyGear6Link = 'MyGear6Link',
  MyGear5Link = 'MyGear5Link',
  MyGearColouredSockets = 'MyGearColouredSockets',

  // *************************************************************
  // Other Gear
  // *************************************************************

  // Gear - Other - Identified
  OtherExcellentIdentifiedGear = 'OtherExcellentIdentifiedGear',
  OtherGoodIdentifiedGear = 'OtherGoodIdentifiedGear',
  OtherExcellentIdentifiedJewellery = 'OtherExcellentIdentifiedJewellery',
  OtherGoodIdentifiedJewellery = 'OtherGoodIdentifiedJewellery',
  OtherExcellentIdentifiedJewels = 'OtherExcellentIdentifiedJewels',
  OtherGoodIdentifiedJewels = 'OtherGoodIdentifiedJewels',
  OtherExcellentIdentifiedCustomItems = 'OtherExcellentIdentifiedCustomItems',
  OtherGoodIdentifiedCustomItems = 'OtherGoodIdentifiedCustomItems',
  OtherIdentifiedRestrictedModItems = 'OtherIdentifiedRestrictedModItems',

  // Gear - Other - Identified - POE2 - All
  OtherAllIdentifiedItems = 'OtherAllIdentifiedItems',

  // Gear - Other - Leveling
  OtherGearLevelingRaresStyle = 'OtherGearLevelingRaresStyle',
  OtherGearLevelingMagicsStyle = 'OtherGearLevelingMagicsStyle',

  // Gear - Other - POE2 - Salvaging
  OtherGearSalvagingSocketed = 'OtherGearSalvagingSocketed',
  OtherGearSalvagingQualityMartialWeapons = 'OtherGearSalvagingQualityMartialWeapons',
  OtherGearSalvagingQualityCasterWeapons = 'OtherGearSalvagingQualityCasterWeapons',
  OtherGearSalvagingQualityArmour = 'OtherGearSalvagingQualityArmour',

  // Gear - Other - POE1 - Recipes
  OtherGearSalvagingRecipeQualityWeapons = 'OtherGearSalvagingRecipeQualityWeapons',
  OtherGearSalvagingRecipeQualityArmour = 'OtherGearSalvagingRecipeQualityArmour',
  OtherGearSalvagingRecipeJewellers = 'OtherGearSalvagingRecipeJewellers',
  OtherGearSalvagingRecipeChromatic = 'OtherGearSalvagingRecipeChromatic',
  OtherGearSalvagingRecipeChaos = 'OtherGearSalvagingRecipeChaos',
  OtherGearSalvagingRecipeExalt = 'OtherGearSalvagingRecipeExalt',

  // ****** POE2 ******

  // Gear - Other - POE2 - Tiered
  OtherGearRareT5 = 'OtherGearRareT5',
  OtherGearRareT4 = 'OtherGearRareT4',
  OtherGearRareT3 = 'OtherGearRareT3',
  OtherGearRareT2 = 'OtherGearRareT2',
  OtherGearMagicT5 = 'OtherGearMagicT5',
  OtherGearMagicT4 = 'OtherGearMagicT4',
  OtherGearMagicT3 = 'OtherGearMagicT3',
  OtherGearMagicT2 = 'OtherGearMagicT2',

  // Gear - Other - POE2 - Tiered Low Tier
  OtherGearLowerGearTierRareT5 = 'OtherGearLowerGearTierRareT5',
  OtherGearLowerGearTierRareT4 = 'OtherGearLowerGearTierRareT4',
  OtherGearLowerGearTierRareT3 = 'OtherGearLowerGearTierRareT3',
  OtherGearLowerGearTierMagicT5 = 'OtherGearLowerGearTierMagicT5',
  OtherGearLowerGearTierMagicT4 = 'OtherGearLowerGearTierMagicT4',
  OtherGearLowerGearTierMagicT3 = 'OtherGearLowerGearTierMagicT3',

  // Gear - Other - POE2 - Exceptional
  OtherGearExcellentExceptionalSocketed = 'OtherGearExcellentExceptionalSocketed',
  OtherGearGoodExceptionalSocketed = 'OtherGearGoodExceptionalSocketed',
  OtherGearExcellentExceptionalQuality = 'OtherGearExcellentExceptionalQuality',
  OtherGearGoodExceptionalQuality = 'OtherGearGoodExceptionalQuality',
  OtherGearILevel82 = 'OtherGearILevel82',
  OtherGearILevel81 = 'OtherGearILevel81',
  OtherGearSpecialGear = 'OtherGearSpecialGear',

  // ****** POE1 ******

  // Gear - Other - POE1 - Special
  OtherGearInfluenced = 'OtherGearInfluenced',
  OtherGearFractured = 'OtherGearFractured',
  OtherGearVeiled = 'OtherGearVeiled',
  OtherGearMemoryStrands = 'OtherGearMemoryStrands',

  // Gear - Other - POE1 - Crafting Bases
  OtherGearExcellentQualityWeapon = 'OtherGearExcellentQualityWeapon',
  OtherGearGoodQualityWeapon = 'OtherGearGoodQualityWeapon',
  OtherGearExcellentQualityArmour = 'OtherGearExcellentQualityArmour',
  OtherGearGoodQualityArmour = 'OtherGearGoodQualityArmour',
  OtherGear6LinkedItems = 'OtherGear6LinkedItems',
  OtherGear5LinkedItems = 'OtherGear5LinkedItems',
  OtherGear6ColourItems = 'OtherGear6ColourItems',
  OtherGear5ColourItems = 'OtherGear5ColourItems',
  OtherGear4ColourItems = 'OtherGear4ColourItems',
  OtherGearExcellentBaseTypes = 'OtherGearExcellentBaseTypes',
  OtherGearGoodBaseTypes = 'OtherGearGoodBaseTypes',

  // Gear - Other - Leveling
  OtherGearLevelingNormal = 'OtherGearLevelingNormal',
  OtherGearLevelingMagic = 'OtherGearLevelingMagic',
  OtherGearLevelingRare = 'OtherGearLevelingRare',
  OtherGearLevelingMagicRareBoots = 'OtherGearLevelingMagicRareBoots',

  // Gear - Other - Leveling - POE1
  OtherGearLevelingExcellentSocketed = 'OtherGearLevelingExcellentSocketed',
  OtherGearLevelingGoodSocketed = 'OtherGearLevelingGoodSocketed',

  // *************************************************************
  // Favourite Jewellery
  // *************************************************************

  // Jewellery - My
  MyJewelleryRegularNormal = 'MyJewelleryRegularNormal',
  MyJewelleryRegularMagic = 'MyJewelleryRegularMagic',
  MyJewelleryRegularRare = 'MyJewelleryRegularRare',

  // Jewellery - Favourite - iLevel
  MyJewelleryExcellentILevel = 'MyJewelleryExcellentILevel',
  MyJewelleryGoodILevel = 'MyJewelleryGoodILevel',

  // ****** POE2 ******

  // Jewellery - Favourite - POE2 - Tiered
  MyJewelleryRareT5 = 'MyJewelleryRareT5',
  MyJewelleryRareT4 = 'MyJewelleryRareT4',
  MyJewelleryRareT3 = 'MyJewelleryRareT3',
  MyJewelleryRareT2 = 'MyJewelleryRareT2',
  MyJewelleryMagicT5 = 'MyJewelleryMagicT5',
  MyJewelleryMagicT4 = 'MyJewelleryMagicT4',
  MyJewelleryMagicT3 = 'MyJewelleryMagicT3',
  MyJewelleryMagicT2 = 'MyJewelleryMagicT2',

  // ****** POE1 ******

  // Jewellery - Favourite - POE1
  MyJewelleryExcellentMemoryStrands = 'MyJewelleryExcellentMemoryStrands',
  MyJewelleryGoodMemoryStrands = 'MyJewelleryGoodMemoryStrands',

  // *************************************************************
  // Other Jewellery
  // *************************************************************

  // ****** POE2 ******

  // Jewellery - Other - POE2 - Tiered
  OtherJewelleryRareT5 = 'OtherJewelleryRareT5',
  OtherJewelleryRareT4 = 'OtherJewelleryRareT4',
  OtherJewelleryRareT3 = 'OtherJewelleryRareT3',
  OtherJewelleryRareT2 = 'OtherJewelleryRareT2',
  OtherJewelleryMagicT5 = 'OtherJewelleryMagicT5',
  OtherJewelleryMagicT4 = 'OtherJewelleryMagicT4',
  OtherJewelleryMagicT3 = 'OtherJewelleryMagicT3',
  OtherJewelleryMagicT2 = 'OtherJewelleryMagicT2',

  // ****** POE1 ******

  // Jewellery - Other - POE1 - Special
  OtherJewelleryInfluenced = 'OtherJewelleryInfluenced',
  OtherJewelleryFractured = 'OtherJewelleryFractured',
  OtherJewelleryVeiled = 'OtherJewelleryVeiled',
  OtherJewelleryMemoryStrands = 'OtherJewelleryMemoryStrands',
  OtherJewelleryAnointedAmulets = 'OtherJewelleryAnointedAmulets',
  OtherJewelleryCorruptedJewels = 'OtherJewelleryCorruptedJewels',
  OtherJewelleryCorruptedJewellery = 'OtherJewelleryCorruptedJewellery',

  // Jewellery - Other - POE1 - Crafting Bases
  OtherJewelleryExcellentClusterJewelBases = 'OtherJewelleryExcellentClusterJewelBases',
  OtherJewelleryGoodClusterJewelBases = 'OtherJewelleryGoodClusterJewelBases',
  OtherJewelleryExcellentBaseTypes = 'OtherJewelleryExcellentBaseTypes',
  OtherJewelleryGoodBaseTypes = 'OtherJewelleryGoodBaseTypes',
  OtherJewelleryExcellentSpecialBaseTypes = 'OtherJewelleryExcellentSpecialBaseTypes',
  OtherJewelleryGoodSpecialBaseTypes = 'OtherJewelleryGoodSpecialBaseTypes',
  OtherJewelleryOtherSpecialBaseTypes = 'OtherJewelleryOtherSpecialBaseTypes',

  // *************************************************************
  // Jewels
  // *************************************************************

  // Jewels - My
  MyJewelsRare = 'MyJewelsRare',
  MyJewelsMagic = 'MyJewelsMagic',

  // ****** POE1 ******

  // Jewels - Favourite - POE1
  MyJewelsExcellentILevel = 'MyJewelsExcellentILevel',
  MyJewelsGoodILevel = 'MyJewelsGoodILevel',

  // *************************************************************
  // Flasks & Charms
  // *************************************************************

  // Flasks & Charms - My
  MyFlasksQuality = 'MyFlasksQuality',
  MyFlasksILevel = 'MyFlasksILevel',
  MyFlasksRegularNormal = 'MyFlasksRegularNormal',
  MyFlasksRegularMagic = 'MyFlasksRegularMagic',

  // Flasks & Charms - Other
  OtherFlasksQuality = 'OtherFlasksQuality',

  // Flasks & Charms - Other - POE2
  OtherCharmsILevel = 'OtherCharmsILevel',

  // Flasks & Charms - Other - POE1
  OtherFlasksILevel = 'OtherFlasksILevel',
  OtherFlasksExcellentQuality = 'OtherFlasksExcellentQuality',
  OtherFlasksGoodQuality = 'OtherFlasksGoodQuality',
  OtherCharmsQuality = 'OtherCharmsQuality',

  // *************************************************************
  // Other Items
  // *************************************************************

  // Items - Other
  ItemsTrialItems = 'ItemsTrialItems',

  NormalGoldStacks = 'NormalGoldStacks',
  LargeGoldStacks = 'LargeGoldStacks',
  HugeGoldStacks = 'HugeGoldStacks',

  NormalVerisiumStacks = 'NormalVerisiumStacks',
  LargeVerisiumStacks = 'LargeVerisiumStacks',
  HugeVerisiumStacks = 'HugeVerisiumStacks',

  // Items - Other - POE1
  ItemsHeistEnchantedBlueprints = 'ItemsHeistEnchantedBlueprints',
  ItemsHeistEnchantedContracts = 'ItemsHeistEnchantedContracts',
  ItemsHeistBlueprints = 'ItemsHeistBlueprints',
  ItemsHeistContracts = 'ItemsHeistContracts',
  ItemsRoguesMarkers = 'ItemsRoguesMarkers',

  // Items - Other - POE2
  ItemsWaystonesRare = 'ItemsWaystonesRare',
  // ItemsWaystonesDelirium = 'ItemsWaystonesDelirium',
  ItemsWaystonesOther = 'ItemsWaystonesOther',

  // *************************************************************
  // POE1 Gems
  // *************************************************************

  GemsTopTierAwakened = 'GemsTopTierAwakened',
  GemsTopTierSpecialSupport = 'GemsTopTierSpecialSupport',
  GemsTopTierExceptionalSupport = 'GemsTopTierExceptionalSupport',
  GemsOtherExceptionalSupport = 'GemsOtherExceptionalSupport',
  GemsImbued = 'GemsImbued',
  GemsLvl21Quality20 = 'GemsLvl21Quality20',
  GemsLvl20Quality20 = 'GemsLvl20Quality20',
  GemsLvl21 = 'GemsLvl21',
  GemsLevel = 'GemsLevel',
  GemsOtherLevel = 'GemsOtherLevel',
  GemsQuality23 = 'GemsQuality23',
  GemsQuality = 'GemsQuality',
  GemsOtherQuality = 'GemsOtherQuality',
  GemsSearched = 'GemsSearched',

  // *************************************************************
  // POE1 Maps
  // *************************************************************

  MapsTier17 = 'MapsTier17',
  MapsTier17Corrupted = 'MapsTier17Corrupted',
  MapsTier16BlightRavaged = 'MapsTier16BlightRavaged',
  MapsTier16MemoryInfluenced = 'MapsTier16MemoryInfluenced',
  MapsTier16MemoryInfluencedCorrupted = 'MapsTier16MemoryInfluencedCorrupted',
  MapsTier16BlightRavagedCorrupted = 'MapsTier16BlightRavagedCorrupted',
  MapsTier16Blighted = 'MapsTier16Blighted',
  MapsTier16Influenced = 'MapsTier16Influenced',
  MapsTier16Delirium = 'MapsTier16Delirium',
  MapsTier16Normal = 'MapsTier16Normal',
  MapsTier16EightMod = 'MapsTier16EightMod',
  // MapsLowTierInfluenced = 'MapsLowTierInfluenced',
  MapsLowTierMemoryInfluenced = 'MapsLowTierMemoryInfluenced',
  MapsLowTierBlighted = 'MapsLowTierBlighted',
  MapsLowTierDelirium = 'MapsLowTierDelirium',
  MapsTier11 = 'MapsTier11',
  MapsTier6 = 'MapsTier6',
  MapsTier1 = 'MapsTier1',
}
